var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(218, 0, 38)",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472 96H243.882l-37.6-50.133A39.997 39.997 0 0 0 174.282 30H40C17.944 30 0 47.944 0 70v372c0 22.056 17.944 40 40 40h432c22.056 0 40-17.944 40-40V136c0-22.056-17.944-40-40-40zM40 60h134.282a10 10 0 0 1 8 4l34.4 45.867A15 15 0 0 0 228.682 116H472c5.514 0 10 4.486 10 10v34H30V70c0-5.514 4.486-10 10-10zm442 382c0 5.514-4.486 10-10 10H40c-5.514 0-10-4.486-10-10V190h452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 270h272c8.284 0 15-6.716 15-15s-6.716-15-15-15H120c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 330H120c-8.284 0-15 6.716-15 15s6.716 15 15 15h192c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7913fbdbc17eebc4a9291d2249354e52.svg";
export { ForwardRef as ReactComponent };